export enum RequestCancelError {
    NAME = 'CanceledError',
    CODE = 'ERR_CANCELED',
    MESSAGE = 'canceled',
}
export enum ServiceCountry {
    IN = "IN",
    NG = "NG",
}
export const OperatingModeOptions = [
    { label: 'All', value: 'All' },
    { label: 'auto', value: 'auto' },
    { label: 'on', value: 'on' },
    { label: 'off', value: 'off' },
];

export const PowerTypeOptions = [
    { label: 'All', value: 'All' },
    { label: 'SinglePhase', value: 'SinglePhase' },
    { label: 'ThreePhase', value: 'ThreePhase' },
];

export const MeterActiveOptions = [
    { label: 'All', value: 'All' },
    { label: 'Active', value: 'Active' },
    { label: 'InActive', value: 'InActive' },
]

export const manufacturerOptions = [
    { label: 'All', value: 'All' },
    { label: 'Sparkmeter', value: 'Sparkmeter' },
    { label: 'VNT', value: 'VNT' },
];

export const statusOption = [
    { label: 'All', value: 'All' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Completed', value: 'Completed' },
]


export const MeterTabKeys = ["meterV1-list", "meterV2-list", "metersWIP-list"];

export const RechargeTabKeys = [
    "customer-recharge",
    "customer-recharged-list",
    "customer-recharge-pending-list",
    "NotRechargedLiveCustomers"
];

export const TransactionsTabKeys = [
    "Transaction",
    "Refund",
];

export const PERMISSION_TYPE = {
    MANAGE_CREATE_SPARKMETER: 'ManageCreateSparkmeter',
    MANAGE_EDIT_SPARKMETER: 'ManageEditSparkmeter',
    MANAGE_METER_LIST: 'ManageMeterList',
    MANAGE_ACTIVE_METER: 'ManageActiveMeter',
    MANAGE_ARCHIVE_METER: 'ManageArchiveMeter',
    BULK_MANAGE_ACTIVE_METER: 'BulkManageActiveMeter',
    BULK_MANAGE_ARCHIVE_METER: 'BulkManageArchiveMeter',
    MANAGE_METERWIP_LIST: 'ManageMeterWipList',
    MANAGE_CREATE_METERWIP: 'ManageCreateMeterWip',
    MANAGE_WAREHOUSE_METER: 'ManageWarehouseMeter',
    MANAGE_DELETE_METER: 'ManageDeleteMeter',
    MANAGE_CREATE_METERV2: 'ManageCreateMeterV2',
    MANAGE_EDIT_METERV2: 'ManageEditMeterV2',
    MANAGE_GLOBAL_OVERVIEW: 'ManageGlobalOverView',
    MANAGE_COUNTRY_OVERVIEW: 'ManageCountryOverView',
    MANAGE_STATE_OVERVIEW: 'ManageStateOverview',
    MANAGE_NOC_OVERVIEW: 'ManageNOCOverview',
    MANAGE_DASHBOARD_SUMMARY: 'ManageDashboardSummary',
    MANAGE_NOC_OPERATIONAL_DASHBOARD: 'ManageNOCOperationalDashboard',
    MANAGE_NOC_CUSTOMER_DASHBOARD: 'ManageNOCCustomerDashboard',
    MANAGE_NOC_FINANCE_DASHBOARD: 'ManageNOCFinanceDashboard',
    MANAGE_PLANT_OPERATIONAL_DASHBOARD: 'ManagePlantOperationalDashboard',
    MANAGE_PLANT_CUSTOMER_DASHBOARD_SUMMARY: 'ManagePlantCustomerDashboardSummary',
    MANAGE_PLANT_CUSTOMER_DASHBOARDLIVE: 'ManagePlantCustomerDashboardLive',
    MANAGE_PLANT_FINANCE_DASHBOARD: 'ManagePlantFinanceDashboard',
    MANAGE_REPORTS: 'ManageReports',
    MANAGE_CUSTOMERLIST: 'ManageCustomerList',
    MANAGE_CUSTOMER_LATESTINFO: 'ManageCustomerLatestInfo',
    MANAGE_CUSTOMER_DETAILS: 'ManageCustomerDetails',
    MANAGE_PLANT360: 'ManagePlant360',
    MANAGE_TARIFF_LIST: 'ManageTariffList',
    MANAGE_MASTER_TARIFF_LIST: 'ManageMasterTariffList',
    MANAGE_CUSTOMER_PLAN_CHANGE: 'ManageCustomerPlanChange',
    MANAGE_TARIFF_PLAN_LIST: 'ManageTariffPlanList',
    MANAGE_PLANT_HEALTH_CHECK: 'ManagePlantHealthCheck',
    MANAGE_PLANT_DOWN_TIME_LIST: 'ManagePlantDownTimeList',
    MANAGE_IOT_DOWN_TIME_LOGLIST: 'ManageIoTDowntimeLogList',
    MANAGE_IOT_DOWN_TIME_SUMMARY: 'ManageIoTDowntimeSummary',
    MANAGE_CUSTOMER_RECHARGES: 'ManageCustomerRecharges',
    MANAGE_CUSTOMER_RECHARGED_LIST: 'ManageCustomerRechargedList',
    MANAGE_CUSTOMER_RECHARGE_PENDING_LIST: 'ManageCustomerRechargePendingList',
    MANAGE_METER_WIP_LIST: 'ManageMeterWipList',
    MANAGE_IOT_REGISTER_FEEDBACK_LIST: 'ManageIOTRegisterFeedbackList',
    MANAGE_EXECUTIVE_TRANSACTIONS_LIST: 'ManageExecutiveTransactionsList',
    MANAGE_PLANT_MAINTENANCE: 'ManagePlantMaintenance',
    ELECTRICIAN_COMPLAINT_MANAGEMENT_LIST: 'ElectricianComplaintManagementList',
    MANAGE_DG_SERIAL_PLANT_DETAILS_LIST: 'ManageDgSerialPlantDetailsList',
    MANAGE_DG_MAINTENANCE_SCHEDULES_LIST: 'ManageDgMaintenanceSchedulesList',
    MANAGE_NEW_CUSTOMER_REVENUE_TARGET_LIST: 'ManageNewCustomerRevenueTargetList',
    MANAGE_INVENTORY_LIST: 'ManageInventoryList',
    MANAGE_OPERATION_DASHBOARD_LIVE_UPDATE_LIST: 'ManageOperationDashboardLiveUpdateList',
    MANAGE_PENDING_CASH_PAYMENT_LIST: 'ManagePendingCashPaymentList',
    ELECTRICIAN_PERFORMANCE: 'ElectricianPerformance',
    MANAGE_FINANCE_IN_PROGRESS: 'ManageFinanceInProgress',
    MANAGE_FINANCE_TRANSACTIONS: 'ManageFinanceTransactions',
    MANAGE_PAYTM_REVERSE_TRANSACTIONS_LIST: 'ManagePaytmReverseTransactionsList',
    MANAGE_WALLET_CREDIT_TRANSACTIONS_LIST: 'ManageWalletCreditTransactionsList',
    MANAGE_BANK_DEPOSIT_LIST: 'ManageBankDepositList',
    MANAGE_EXPENSE_LIST: 'ManageExpenseList',
    MANAGE_COLLAPSED_LIST: 'ManageCollapsedList',
    MANAGE_BUDGET_LIST: 'ManageBudgetList',
    MANAGE_OFFLINE_METER_DETAILS_LIST: 'ManageOfflineMeterDetailsList',
    MANAGE_ADVANCE_RECHARGE_LIST: 'ManageAdvanceRechargeList',
    MANAGE_TRANSACTION_LIST: 'ManageTransactionList',
    MANAGE_CASH_TRANSACTION_LIST: 'ManageCashTransactionList',
    MANAGE_TRANSACTION_HISTORY_LIST: 'ManageTransactionHistoryList',
    MANAGE_PRODUCT_LIST: 'ManageProductList',
    MANAGE_DISCOUNT_LIST: 'ManageDiscountList',
    MANAGE_AGENT_LIST: 'ManageAgentList',
    MANAGE_AGENT_COMMISSION_SCHEME: 'ManageAgentCommissionScheme',
    MANAGE_WISHLIST: 'ManageWishlist',
    MANAGE_GUEST_CUSTOMER_LIST: 'ManageGuestCustomerList',
    SALES_EXECUTIVE_VISIT_TRACKING_LIST: 'SalesExecutiveVisitTrackingList',
    MANAGE_AGENT_CUSTOMER_LIST: 'ManageAgentCustomerList',
    MANAGE_AGENT_CUSTOMER_RECHARGE: 'ManageAgentCustomerRecharge',
    MANAGE_AGENT_CUSTOMER_PLAN_CHANGE: 'ManageAgentCustomerPlanChange',
    MANAGE_AGENT_DASHBOARD: "ManageAgentDashboard",
    MANAGE_AGENT_CREDIT_LIST: "ManageAgentCreditList",
    MANAGE_CAMPAIGN_LIST: "ManageCampaignList",
    MANAGE_GENERATION_POTENTIAL_LIST: "ManageGenerationPotentialList",
    MANAGE_PLANT_DETAILS_LIST: "ManagePlantDetailsList",
    MANAGE_PLANT_PIPELINE_LIST: "ManagePlantPipelineList",
    MANAGE_POLE_MANAGEMENT_LIST: "ManagePoleManagementList",
    MANAGE_COUNTRY_LIST: "ManageCountryList",
    MANAGE_STATE_LIST: "ManageStateList",
    MANAGE_NOC_LIST: "ManageNOCList",
    MANAGE_BLOCK_RATE_TYPE_LIST: "ManageBlockRateTypeList",
    MANAGE_TOU_PERIOD_TYPE_LIST: "ManageTOUPeriodTypeList",
    MANAGE_TEMPLATE_LIST: "ManageTemplateList",
    MANAGE_PLANT_DOWN_TIME_TICKET_LIST: "ManagePlantDownTimeTicketList",
    OPERATION_DASHBOARD_MONTHLY_SUMMARY_LIST: "OperationDashboardMonthlySummaryList",
    CUSTOMER_DASHBOARD_MONTHLY_SUMMARY_LIST: "CustomerDashboardMonthlySummaryList",
    FINANCE_DASHBOARD_MONTHLY_SUMMARY_LIST: "FinanceDashboardMonthlySummaryList",
    MANAGE_EMPLOYEE_LIST: "ManageEmployeeList",
    MANAGE_ITEM_ATTRIBUTE_LIST: "ManageItemAttributeList",
    MANAGE_SETTINGS_LIST: "ManageSettingsList",
    MANAGE_EMAIL_TEMPLATE_LIST: "ManageEmailTemplateList",
    MANAGE_QUEUED_EMAIL_LIST: "ManageQueuedEmailList",
    MANAGE_REWARD_PRODUCT_LIST: "ManageRewardProductList",
    MANAGE_CUSTOMER_REWARD_PRODUCT_MAPPING_LIST: "ManageCustomerRewardProductMappingList",
    MANAGE_CUSTOMER_REWARD_LIST: "ManageCustomerRewardList",
    NOTIFICATION_LIST: "NotificationList",
    IOT_EXPORT_TO_CSV: "IOTExportToCsv",
    IOT_TRANSACTION_LIST: 'IOTTransactionList',
    MANAGE_KYC_LIST: "ManageKYCList",
    MANAGE_COMPLAINT_LIST: "ManageComplaintList",
    MANAGE_SURVEY_LIST: "ManageSurveyList",
    MANAGE_USER_LIST: "ManageUserList",
    MANAGE_USER_ROLE_LIST: "ManageUserRoleList",
    MANAGE_PERMISSION_LIST: "ManagePermissionList",
    MANAGE_PERMISSION_CATEGORY_LIST: "ManagePermissionCategoryList",
    MANAGE_LOG_LIST: "ManageLogList",
    MANAGE_API_LOG_LIST: "ManageApiLogList",
    MANAGE_USER_ACTIVITY_LIST: "ManageUserActivityList",
    MANAGE_USER_LOG_TIMES_LIST: "ManageUserLogTimesList",
    MANAGE_BULK_SMS_LIST_VIEW: "ManageBulkSMSListView",
    MANAGE_BULK_SMS_UPLOAD: "ManageBulkSMSUpload",
    MANAGE_AUTOPAY_RECHARGE_LIST:"ManageAutoPayRechargeList",
    MANAGE_VIEW_POWER_BI_REPORTS:"ManageViewPowerBIReports",
    MANAGE_BULK_SMS: "ManageBulkSMS",
    MANAGE_LIST_PLANT_DOCUMENT: "ManageListPlantDocument",
    MANAGE_PLANT_SERVER_PLANT_DETAILS_LIST: "ManagePlantServerPlantDetailsList",
    MANAGE_EXPORT_OFFLINE_METER_DETAILS_LIST: "ManageExportOfflineMeterDetailsList",
    MANAGE_DISSOCIATE_METER_V2: "ManageDissociateMeterV2",
}
export enum POWER_BI_ACTIVE_TAB_OPTIONS {
    PATTERNS = "Patterns",
    HEALTH = "Health",
}


export const COLUMN_OPTIONS_NG_BULK_SMS = [
  { value: "Select field", label: "Select field", placeholder: "" },
  { value: "Name", label: "Name", placeholder: "Enter Name" },
  { value: "FileName", label: "File Name", placeholder: "Enter File Name" },
  { value: "Status", label: "Status", placeholder: "Enter Status" },
  { value: "Date", label: "Date", placeholder: "Enter Date" },
];

export const COLUMN_OPTIONS_MANUAL_CASH_PAYMENTS = [
  { value: "Select field", label: "Select field", placeholder: "" },
  { value: "FileType", label: "File Type", placeholder: "Enter File Type" },
  { value: "FileName", label: "File Name", placeholder: "Enter File Name" },
  { value: "CreatedOnLocalDateTime", label: "Created On", placeholder: "Enter Created On" },
  { value: "Status", label: "Status", placeholder: "Enter Status" },
];


export enum PaymentType {
  BulkTopUp = "BulkTopUp",
  BulkBonus = "BulkBonus",
}

export enum CustomerType {
  PREPAID = "prepaid",
  POSTPAID = "postpaid",
}